// src/features/compartilhamento/canaisCompartilhamento.js
//
// Canais de compartilhamento — fonte única do app (espelho do
// functions/handlers/compartilhamentoSocial.js CANAIS).
//
// Por que o canal é DECLARADO e não detectado: a folha do sistema devolve
// `activityType` só às vezes (no Android depende do chooser da fabricante; no
// iOS vem a UTI, que muitos apps não registram) e nunca quando o compartilhar é
// pela web. Adivinhar levaria a creditar/verificar com base num palpite. Então
// a pessoa escolhe, e o `activityType` entra apenas como PISTA para
// pré-selecionar — gravado em campo separado, para dar para auditar depois o
// quanto a pista acerta.

export const CANAIS = Object.freeze({
  INSTAGRAM: 'INSTAGRAM',
  WHATSAPP: 'WHATSAPP',
  OUTRO: 'OUTRO',
});

export const CANAL_ROTULO = Object.freeze({
  INSTAGRAM: 'Instagram',
  WHATSAPP: 'WhatsApp',
  OUTRO: 'Outro',
});

// Trechos que aparecem no activityType de cada plataforma:
//   Android → pacote ("com.instagram.android", "com.whatsapp", "com.whatsapp.w4b")
//   iOS     → UTI/bundle ("com.burbn.instagram.shareextension", "net.whatsapp.WhatsApp…")
const PISTAS = [
  [CANAIS.INSTAGRAM, ['instagram', 'burbn']],
  [CANAIS.WHATSAPP, ['whatsapp']],
];

/**
 * Traduz o `activityType` da folha nativa em canal — só para pré-selecionar.
 * @param {string} activityType
 * @return {string|null} CANAIS.* ou null quando não dá para dizer
 */
export function canalDaPista(activityType) {
  const texto = String(activityType || '').toLowerCase();
  if (!texto) return null;
  for (const [canal, termos] of PISTAS) {
    if (termos.some((t) => texto.includes(t))) return canal;
  }
  return null;
}
